import Monitor from './_monitor';
import MonitorsToolbar from './_monitors_toolbar';
import RivalsFilter from './_rivals_filter';
import Icon from './_icon';

import {monitorGet} from '../modules/api/monitors';
import {MONITORS_PER_PAGE} from '../modules/constants/api';

import {DropdownMenuConstants} from '../modules/constants/dropdown_menu';

import ReactPaginate from 'react-paginate';
import ReactTooltip from 'react-tooltip';
import {withRouter} from 'react-router-dom';

class Monitors extends React.Component {

  static contextTypes = {
    api: PropTypes.object.isRequired,
    appData: PropTypes.object.isRequired
  };

  static propTypes = {
    history: PropTypes.object,
    location: PropTypes.object,
    user: PropTypes.object
  };

  static defaultProps = {
    history: {},
    location: {},
    user: {csrf: ''}
  };

  // Set up initial state
  state = {
    // state
    monitors: [],
    deletedMonitors: [],
    expandedMonitor: {id: null}, // monitor id
    resultsToShow: MONITORS_PER_PAGE,
    resultsLoaded: false,
    resultsTotal: 0,
    page: parseInt(new URLSearchParams(this.props.location.search).get('page'), 10) ?? 1,
    // if this query param is provided in  URL, we load only the specified monitor
    monitorIdQueryParam: parseInt(new URLSearchParams(this.props.location.search).get('monitor'), 10) ?? null,

    // user filters
    view: 'ALL', // HIGHLIGHTS, FULLPAGE
    sort: 'CHANGED', // CHANGED, CREATED
    filterByUserId: DropdownMenuConstants.MONITORED_PAGES_FILTER_SHOW_EVERYONE,
    filterByRivals: new URLSearchParams(this.props.location.search).getAll('rivals').map(Number) ?? []
  };

  componentDidMount() {
    // DEBUG
    console.log('Monitors.componentDidMount: props: %o', this.props);
    this._isMounted = true;
    this.loadResultsOfCurrentState();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  resetResultsState = () => {
    this.setState({
      monitors: [],
      resultsToShow: MONITORS_PER_PAGE,
      expandedMonitor: null,
      resultsLoaded: false
    });
  };

  resetAll = () => {
    this.resetResultsState();
    this.setState({
      view: 'ALL',
      filterByUserId: -1,
      sort: 'CHANGED',
      filterByRivals: []
    }, this.loadResultsOfCurrentState);
  };

  loadResultsOfCurrentState = () => {
    const {filterByRivals, monitorIdQueryParam, page, view, sort, filterByUserId, deletedMonitors} = this.state;
    const typeParamMap = {
      ALL: null,
      HIGHLIGHTS: 'highlights',
      FULLPAGE: 'page'
    };

    const sortParamMap = {
      CHANGED: 'last_change_at',
      CREATED: 'created_at'
    };

    // when a monitor Id is provided in URL, we will just show that single monitor.
    if(monitorIdQueryParam) {
      return monitorGet(monitorIdQueryParam, {hasChanged: true})
        .then(monitor => {
          // in case there is no monitor associated with the id, we will reset the query param and show all the monitors
          if(_.isEmpty(monitor)) {
            this.props.history.push({search: ''});

            return this.setState({
              monitorIdQueryParam: null
            }, () => {
              this.loadResultsOfCurrentState();
            });
          }

          return this.setState({
            monitors: [monitor],
            resultsLoaded: true,
            resultsTotal: 1
          }, () => {
            ReactTooltip.rebuild();
          });
        });
    }

    const queryParams = {
      type: typeParamMap[view] || typeParamMap.ALL,
      sort: sortParamMap[sort] || sortParamMap.CHANGED,
      page: page || 1,
      limit: MONITORS_PER_PAGE,
      hasChanged: true,
      startDate: '2000-01-01' // override api default to make sure we get all results
    };

    if(filterByRivals.length) {
      queryParams.rivalIds = filterByRivals;
    }

    if(filterByUserId > 0) {
      queryParams.userId = filterByUserId;
    }

    this.context.api.monitorsGet(queryParams, ({items, totalItems}) => {
      // Make sure we're not including anything we've deleted (since deletion happens via a delayed job, we can't rely on the op being complete)
      if(Array.isArray(deletedMonitors) && deletedMonitors.length) {
        deletedMonitors.forEach(monitorId => {
          const idx = items.findIndex(el => el.id === monitorId);

          if(idx > -1) {
            items.splice(idx, 1);
          }
        });
      }

      this.setState({
        monitors: items,
        resultsLoaded: true,
        monitorIdQueryParam: null,
        resultsTotal: totalItems
      }, () => {
        ReactTooltip.rebuild();
      });
    });
  };

  isFilterChecked = (rival = null, filterByRivals = []) => {
    if(_.isEmpty(rival) || _.isNil(rival.id) || _.isEmpty(filterByRivals)) {
      return false;
    }

    return filterByRivals.includes(rival.id);
  };

  addOrDelete = (item, list = []) => {
    const itemIndex = list.indexOf(item);

    if(itemIndex >= 0) {
      list.splice(itemIndex, 1);

      return list;
    }

    return list.concat([item]);
  };

  // events
  handleViewClick = sort => {
    this.resetResultsState();
    this.setState({
      view: sort
    }, () => {
      this.loadResultsOfCurrentState();
    });
  };

  handleViewSortClick = view => {
    this.resetResultsState();
    this.setState({
      sort: view
    }, () => {
      this.loadResultsOfCurrentState();
    });
  };

  handleUserFilterClick = userId => {
    this.resetResultsState();
    this.setState({
      filterByUserId: userId
    }, this.loadResultsOfCurrentState);
  };

  handleRivalClick = (rival = null) => {
    const {filterByRivals, monitorIdQueryParam} = this.state;
    let newFilters;

    if(!rival) {
      newFilters = [];
    }
    else {
      const filters = (filterByRivals || []).slice();

      newFilters = this.addOrDelete(rival.id, filters);
    }

    if(monitorIdQueryParam) {this.props.history.push({search: ''});}

    this.setState({
      filterByRivals: newFilters,
      resultsLoaded: false,
      monitorIdQueryParam: null
    }, this.loadResultsOfCurrentState);
  };

  handleExpand = highlightId => {
    if(this.state.expandedMonitor === highlightId) {
      highlightId = null;
    }

    this.setState({expandedMonitor: highlightId});
  };

  handleDelete = monitorId => {
    const monitors = (this.state.monitors || []).filter(monitor => monitor.id !== monitorId);
    const deletedMonitors = this.state.deletedMonitors || [];

    deletedMonitors.push(monitorId);

    this.setState({
      monitors,
      deletedMonitors
    });
  };

  renderMonitor = monitor => {
    const {expandedMonitor, monitorIdQueryParam} = this.state;
    const {id: monitorId, type, url} = monitor;
    const lastUpdate = moment(monitor.lastChangeAt).fromNow();

    const monitors = monitor.highlights.map(highlight => {
      return (
        <Monitor
          handleDelete={this.handleDelete}
          handleExpand={this.handleExpand}
          id={monitorId}
          highlightId={highlight.id}
          isExpanded={expandedMonitor === highlight.id}
          preExpanded={Boolean(monitorIdQueryParam)}
          key={`${monitorId}-${highlight.id}`}
          lastUpdate={lastUpdate}
          title={highlight.context}
          type={type}
          url={url}
          user={this.props.user} />
      );
    });

    return monitors;
  };

  handlePageClick = data => {
    const page = data.selected + 1;

    this.setState({
      page
    }, this.loadResultsOfCurrentState);
  };

  renderPaginator = () => {
    const pageCount = Math.ceil(this.state.resultsTotal / this.state.resultsToShow);
    const forcePage = this.state.page ? this.state.page : 1;
    const iconPrevious = (
      <Icon icon="arrow-left" />
    );
    const iconNext = (
      <Icon icon="arrow-right" />
    );

    return pageCount <= 1 ? null : (
      <div className="pagination-monitors">
        <ReactPaginate
          previousLabel={forcePage === 1 ? null : iconPrevious}
          nextLabel={forcePage === pageCount ? null : iconNext}
          breakLabel={<span>...</span>}
          breakClassName={'break-me'}
          forcePage={forcePage - 1}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={this.handlePageClick}
          containerClassName={'pagination'}
          subContainerClassName={'pages pagination'}
          activeClassName={'paginator_active'} />
      </div>
    );
  };

  render() {
    const {view, sort, filterByUserId, resultsTotal, resultsLoaded, monitorIdQueryParam} = this.state;
    const {appData: {helpDocsHost}} = this.context;
    const monitors = (this.state.monitors || []).slice();
    const filterByRivals = (this.state.filterByRivals || []).slice();
    const showNoResults = !monitors.length && resultsLoaded;
    let uiNoResults;

    if(showNoResults) {
      uiNoResults = filterByRivals.length === 0
        ? (
          <div className="monitors-no-results">
            Nothing to see here. Yet!
            <div className="monitors-no-results_message">
              Any webpages setup for monitoring will be listed here when changes are detected.
              <br />
              <strong><a href={`//${helpDocsHost}/article/uv16bhuld4-how-do-i-start-monitoring-a-pagewhat-s-new`}>
                Learn how to monitor pages
              </a></strong>.
            </div>
          </div>
        )
        : (
          <div className="monitors-no-results">
            No results found 😢
            <div className="monitors-no-results_message">
              <strong>
                <a
                  href="#"
                  onClick={e => {
                    if(e) {
                      e.preventDefault();
                      e.stopPropagation();
                    }

                    this.resetAll();
                  }}>Clear all filters
                </a>
              </strong> to view more results.
            </div>
          </div>
        );
    }

    return (
      <div className="container">
        <ReactTooltip
          class="tooltip"
          html={true}
          effect="solid"
          offset={{top: 0}} />
        <div className="monitors-layout">
          <MonitorsToolbar
            handleSortByClick={this.handleViewSortClick}
            handleTypeFilterClick={this.handleViewClick}
            handleUserFilterClick={this.handleUserFilterClick}
            selections={{
              typeFilterDropdown: view,
              sortByDropdown: sort,
              userFilterDropdown: filterByUserId
            }} />
          <div className="monitors-wrapper">
            <div ref="sideBar" className="monitors-layout_sidebar">
              <RivalsFilter
                filterByRivals={filterByRivals}
                totalCount={resultsTotal}
                testIfChecked={rival => this.isFilterChecked(rival, filterByRivals)}
                onRivalClick={this.handleRivalClick}
                viewingSingleMonitor={Boolean(monitorIdQueryParam)} />
            </div>
            <div className="monitor-layout_body" ref="resultContainer">
              <div className="monitor-layout_body_inner">
                {monitors.map(monitor => this.renderMonitor(monitor))}
                {uiNoResults}
              </div>
              {this.renderPaginator()}
            </div>
          </div>
        </div>
      </div>
    );
  }

}

export default withRouter(Monitors);
